import { __module as string } from "../../../../../../../_virtual/string.js";
import { __require as requireNode } from "./node.js";
import { __require as requireTypes } from "./types.js";
var hasRequiredString;
function requireString() {
  if (hasRequiredString) return string.exports;
  hasRequiredString = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = void 0;
    var _node = _interopRequireDefault(requireNode());
    var _types = requireTypes();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
        o2.__proto__ = p2;
        return o2;
      };
      return _setPrototypeOf(o, p);
    }
    var String = /* @__PURE__ */ (function(_Node) {
      _inheritsLoose(String2, _Node);
      function String2(opts) {
        var _this;
        _this = _Node.call(this, opts) || this;
        _this.type = _types.STRING;
        return _this;
      }
      return String2;
    })(_node["default"]);
    exports$1["default"] = String;
    module.exports = exports$1.default;
  })(string, string.exports);
  return string.exports;
}
export {
  requireString as __require
};
//# sourceMappingURL=string.js.map
